import React from 'react';
import {Col, Row}from 'react-bootstrap';

const OutletDetailField = ({label, data}) => {
    return (
        <Row>
            <Col md={6}>{label}:</Col>
            <Col md={6}>{data}</Col>
        </Row>
    )
};

export default OutletDetailField;


// WEBPACK FOOTER //
// ./src/components/admin/outlet-view/outlet-detail-field.jsx